import React from 'react'
import Box from '@material-ui/core/Box'
import Container from '@material-ui/core/Container'
import Typography from '@material-ui/core/Typography'
import blue from '@material-ui/core/colors/blue'
import { makeStyles } from '@material-ui/core/styles'

const useStyles = makeStyles({
  infoBox: {
    textAlign: 'center',
    backgroundColor: blue[50],
    marginTop: '1rem',
  },
})

const InfoBox = ({ text, maxWidth = null }) => {
  const classes = useStyles()

  return (
    <Container maxWidth={maxWidth}>
      <Box p={1} mb={3} borderRadius={4} className={classes.infoBox}>
        <Typography variant="body2">{text}</Typography>
      </Box>
    </Container>
  )
}

export default InfoBox
